// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W3bR","placeholdersHeader":"styles_placeholdersHeader__3az10","editorStyle":"styles_editorStyle__1K7Yv","placeholdersBox":"styles_placeholdersBox__3DXNq"};